import { uniqueHeadingSlug } from '../../libraries/BBCode/headingSlug'

function stripBbcode(text) {
  return String(text || '')
    .replace(/\[[^\]]+\]/g, '')
    .trim()
}

/**
 * Extrae entradas de índice desde BBCode crudo (mismo orden que el parser).
 */
export function extractTocFromBBCode(bbcode) {
  if (!bbcode || typeof bbcode !== 'string') return []

  const items = []
  const usedSlugs = new Set()
  const pattern = /\[(h2|h3)\]([\s\S]*?)\[\/\1\]/gi
  let match = pattern.exec(bbcode)

  while (match) {
    const level = match[1].toLowerCase() === 'h3' ? 3 : 2
    const title = stripBbcode(match[2])
    if (title) {
      items.push({
        level,
        title,
        id: uniqueHeadingSlug(title, usedSlugs),
      })
    }
    match = pattern.exec(bbcode)
  }

  if (!items.length) {
    const spoilerRe = /\[spoiler=([^\]]+)\]/gi
    let sm = spoilerRe.exec(bbcode)
    while (sm) {
      const title = stripBbcode(sm[1])
      if (title) {
        items.push({
          level: 2,
          title,
          id: uniqueHeadingSlug(title, usedSlugs),
        })
      }
      sm = spoilerRe.exec(bbcode)
    }
  }

  return items
}

export function formatVolumeLabel(sortOrder, index) {
  const n = Number.isFinite(Number(sortOrder)) ? Number(sortOrder) : index
  const vol = Math.max(1, n + 1)
  const romans = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X']
  if (vol <= romans.length) return `Volumen ${romans[vol - 1]}`
  return `Volumen ${vol}`
}

export function formatUpdatedAt(iso) {
  if (!iso) return null
  try {
    return new Intl.DateTimeFormat('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(new Date(iso))
  } catch {
    return null
  }
}
